import { type Product, Query } from '~/Api/Product';
import { SelectionTypes } from '~/GroupProduct';

import type { IGroupProductManager } from '~/GroupProduct/GroupProductManager';
import type { PublicApi } from '~/Types/helpers';
import type { UserProductGroup } from '~/Api/User/ProductGroup';

export type ICopyGroupProductManager = PublicApi<CopyGroupProductManager>;

export default class CopyGroupProductManager {
	constructor(private readonly services: { groupProductManager: IGroupProductManager }) {}

	copyProductGroup(
		group: UserProductGroup,
		products: Product[],
		options: {
			flashMessageText?: string;
		} = {}
	): Promise<void> {
		return this.services.groupProductManager.handleProductGroupAddition(
			group,
			{
				type: SelectionTypes.products,
				products: new Set(products),
				query: new Query([]),
			},
			options
		);
	}
}
